<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/appointment/${inputs.id}`
						: `transaction/appointment`
				"
			>
				<div
					class="form-group row align-items-center"
				>
					<label for="placement_type" class="col-sm-3 mb-0">
						Appointment Type
					</label>
					<app-input
						id="placement_type"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.placement_type"
						:list="typeOfPlacementLists"
						@input="handleAppointmentChange"
						placeholder="Appointment Type"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProductLevel">
					<label for="inputs_product_level_id" class="col-sm-3 mb-0">
						Product level
					</label>
					<app-input
						id="inputs_product_level_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_level_id"
						@input="setProductLevelIdValue"
									fetch-url="master/product-level"
						placeholder="Product Level"
						list-value-field="product_level_desc"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_id"
						@input="setProductIdValue"
						:fetch-url="inputs.product_level_id ? `master/product?product_category_exclude=3,2&product_level_id=${inputs.product_level_id}` : ''"
						placeholder="Product Name"
						:disabled="!inputs.product_level_id"
						list-value-field="name"
						required
					/>
				</div>
				
				<div class="form-group row align-items-center" v-if="showPackageName">
					<label for="inputs_packages_name" class="col-sm-3 mb-0">
						Package Name
					</label>
					<app-input
						id="inputs_packages_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_packages_name"
						@input="setPackagesNameValue"
						:fetch-url="inputs.product_id ? `master/list-packages?product_id=${inputs.product_id}` : ''"
						placeholder="Packages Name"
						list-value-field="package_name"
						:disabled="!inputs.product_id"
						required
					/>
				</div>
				<div
					class="form-group row align-items-center"  v-if="showLocationTest"
				>
					<label for="inputs_location_test" class="col-sm-3 mb-0">
						Location Test
					</label>
					<app-input
						id="inputs_location_test"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.location_test"
						:list="locationTestList"
						placeholder="Location Test"
						:required="true"
						@input="handleLocationChange"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showCenterLocationTest">
					<label for="inputs_center" class="col-sm-3 mb-0">
						Center
					</label>
					
					<app-input
						id="inputs_center"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center"
						@input="setCenterValue"
						fetch-url="/master/center?per_page=50"
						:placeholder="'Center'"
						list-value-field="name"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showBookingDate">
					<label for="inputs_booked_date" class="col-sm-3 mb-0">
						Book Date
					</label>
					<app-input
						id="inputs_booked_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.book_date"
						placeholder="Book Date"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showBookingTime">
					<div class="col-sm-3 mb-0">
						<label for="inputs_booked_time" >
							Book Time
						</label>
					</div>
					<div class="col-sm-9 mb-0">
						<input
							id="inputs_booked_time"
							class="form-control"
							type="time"
							v-model="inputs.book_time"
							ref="bookedTimeInput"
							placeholder="Book Time"
							:required="true"
						/>
					</div>
				</div>
				<!-- <div class="form-group row align-items-center" v-if="showStatus">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						v-if="selectedUrl != '' || selectedUrl != null"
						id="inputs_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_status"
						@input="setStatusValue"
						fetch-url="/master/lead-status?lead_status_id=null&per_page=50"
						:placeholder="'Status'"
						list-value-field="status"
						disabled
					/>
					<app-input
						v-else
						id="inputs_status"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.status"
						:list="statusLists"
						placeholder="Status"
						:disabled="true"
					/>
				</div> -->
				<!-- Sub Status -->
				<!-- <div class="form-group row align-items-center"  v-if="showSubStatus">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=${input_status.id}&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
						:disabled="
							this.input_status.id === '' ||
							this.input_status.id === null ||
							this.input_status.id === 0
						"
					/>
				</div> -->
				
				<div class="form-group row align-items-center"  v-if="showReason">
					<label for="inputs_name" class="col-sm-3 mb-0">
						Note To Teacher
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.reason"
						:placeholder="'Note To Teacher'"
					/>
				</div>
				
				<div class="form-group row align-items-center" >
					<label for="inputs_teacher_id" class="col-sm-3 mb-0">
						Teacher
					</label>
					<app-input
						id="inputs_teacher_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_assignee_id"
						placeholder="Teacher"
						list-value-field="full_name"
						disabled
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showAssignTo">
					<label for="inputs_examiner_id" class="col-sm-3 mb-0">
						Examiner 
					</label>
					<app-input
						id="inputs_examiner_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.examiner_id"
						placeholder="Examiner"
						:list="assignedToLists"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";

export default {
	name: "BookingForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			assignedToLists: [],
			modalId: this.formId,
			modalTitle: this.$t("add"),
      		input_product_id: {},
			input_product_level_id:{},
    		input_packages_name: {},  
			input_assignee_id:{},
			hideReason: true,
			showProduct : false,
			showProductLevel:false,
			showPackageName : false,
			showBookingDate: true,
			showBookingTime: true,
			showCenterLocationTest: false,
			showLocationTest : false,
			// showStatus: false,
			showReason: true,
			showAssignTo: true,
			// showSubStatus : true,
			showReason : true,
			inputs: {
				// appointment_type: "",
				book_date: "",
				book_time: "",
				examiner_id:'',
				placement_type: "",
				interested_in: "",
				// status: this.value?.status?.id || 0,
				// sub_status: this.value?.sub_status?.id || 0,
				reason:  '',
				clc_id_number: this.value.clc_id_number,
			},
			// appointmentTypeLists: [],
			// statusLists: [],
			locationTestList : [
				{ id: "Onsite", value: "Onsite" },
				{ id: "Online", value: "Online" }
			],
			typeOfPlacementLists: [
				{ id: 1, value: "Class Trial" },
				{ id: 2, value: "Placement Test" },
				{ id: 3, value: "Direct" },
			],
			interestedToReceivedNewsFromClcLists: [
				{ id: 1, value: "Not Interested" },
				{ id: 2, value: "Yes, Via SMS" },
				{ id: 3, value: "Yes, Via WhatsApp" },
			],
			input_center : this.value
				? this.value.id
					? {
							id: this.value.id || 0,
							status: this.value.name || "",
					  }
					: {
							id: this.value?.id || 0,
							status: this.value?.name || "",
					  }
				: {
						id: this.value.id || 0,
						status: this.value.name || "",
				  },
			// input_status: this.value
			// 	? this.value.status
			// 		? {
			// 				id: this.value.status.id || 0,
			// 				status: this.value.status.status || "",
			// 		  }
			// 		: {
			// 				id: this.value.status?.id || 0,
			// 				status: this.value.status?.status || "",
			// 		  }
			// 	: {
			// 			id: this.value.status.id || 0,
			// 			status: this.value.status.status || "",
			// 	  },
			// input_sub_status: this.value
			// 	? this.value.sub_status
			// 		? {
			// 				id: this.value.sub_status.id || 0,
			// 				status: this.value.sub_status.status || "",
			// 		  }
			// 		: {
			// 				id: this.value.sub_status?.id || 0,
			// 				status: this.value.sub_status?.status || "",
			// 		  }
			// 	: {
			// 			id: this.value.sub_status.id || 0,
			// 			status: this.value.sub_status.status || "",
			// 	  },
			// input_reason: this.value
			// 	? this.value.status_reason
			// 		? {
			// 				id: this.value.status_reason.id || 0,
			// 				reason: this.value.status_reason.reason || "",
			// 		  }
			// 		: {
			// 				id: this.value.status_reason?.id || 0,
			// 				reason: this.value.status_reason?.reason || "",
			// 		  }
			// 	: {
			// 			id: this.value.status_reason.id || 0,
			// 			reason: this.value.status_reason.reason || "",
			// 	  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
		this.fetchData();
	},
	mounted() {
		// Pastikan DOM sudah ter-render
		// this.$nextTick(() => {
		// // Cari elemen <input> di dalam komponen app-input
		// const inputElement = this.$refs.bookedTimeInput.$el.querySelector('input');
		// if (inputElement) {
		// 	inputElement.setAttribute('type', 'time');
		// }
		// });
	},
	computed: {
	},
	methods: {
		async fetchData() {
			try {
				let [
					// leadStatusResponse,
					userResponse,
				] = await Promise.all([
					// axios.get(
					// 	"/master/lead-status?lead_status_id=null&per_page=50"
					// ),
					axios.get("/user-list?per_page=50"),
				]);

				// leadStatusResponse.data.data.forEach((item) => {
				// 	this.statusLists.push({
				// 		id: item.id,
				// 		value: item.status,
				// 	});

				// 	if (this.selectedUrl == "" || this.selectedUrl == null) {
				// 		if (item.status.toLowerCase() == "lead") {
				// 			this.inputs.status = item.id;
				// 		}
				// 	}
				// });

				userResponse.data.data.forEach((item) => {
					this.assignedToLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		setPackagesNameValue(data) {

			this.inputs.package_name = data.package_name;
			this.input_packages_name = data;
			const firstCourse = data.courseListPackages?.[0];

			if (!firstCourse) {
				Swal.fire({
					icon: 'warning',
					title: '',
					text: 'invalid package, please check again.',
				});
				return false;
			}

			const teacher = firstCourse.course?.teacher;

			if (!teacher || !teacher.id) {
				Swal.fire({
					icon: 'warning',
					title: '',
					text: 'invalid package, please check again.',
				});
				return false;
			}

			this.input_assignee_id = teacher;
			this.inputs.assignee_id = teacher.id;
		},
		handleLocationChange(value) {
			if(value == 'Onsite'){
				this.showCenterLocationTest = true;
			}else{
				this.showCenterLocationTest = false;
			}
		},
		handleAppointmentChange(value) {
			if(value != 3){

				this.showProduct = false;
				this.showProductLevel = false;
				this.showPackageName = false;
					
				if(value != 1){
					this.showLocationTest = true;
					if(this.inputs.location_test == 'Onsite'){
						this.showCenterLocationTest = true;
					}
				}else{
					this.showLocationTest = false;
					this.showCenterLocationTest = false;
					this.showProduct = true;
					this.showProductLevel = true;
					this.showPackageName = true;
				}

				
				this.showBookingDate = true;
				this.showBookingTime = true;
				// this.showStatus = false;
				this.showReason = true;
				this.showAssignTo = true;
				// this.showSubStatus = true;
				
			}else if(value == 3){
				this.showProductLevel = true;
				this.showProduct = true;
				this.showPackageName = true;
				this.showCenterLocationTest = false;
				this.showLocationTest = false;
				this.showBookingDate = false;
				this.showBookingTime = false;
				// this.showStatus = false;
				this.showReason = false;
				this.showAssignTo = false;
				// this.showSubStatus = false;
				
			}
		},
		submit() {
			(this.inputs.description = "?"),
				(this.inputs.book_date = this.formatDate(
					this.inputs.book_date
				)),
				(this.inputs.completion_date = null),
				(this.inputs.completion_time = null),
				this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},
		formatDate(date) {
			if (date) {
				let newDate = new Date(date);
				return newDate.toISOString().slice(0, 10);
			}
		},

		// setStatusValue(data) {
		// 	this.inputs.status = this.inputs.status;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.status = data.id;
		// 	}
		// },
		setCenterValue(data) {
			this.input_center = data;
			this.inputs.center_id = this.inputs.center_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
		// setSubStatusValue(data) {
		// 	this.inputs.sub_status = this.inputs.sub_status;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.sub_status = data.id;
		// 	}
		// },
		// setReasonValue(data) {
		// 	this.inputs.reason = this.inputs.reason;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.reason = data.id;
		// 	}
		// },
		setProductLevelIdValue(data){
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_level_id", data.id);
			}
						
			this.inputs.product_level_id = data?.id || null;

			// reset package kalau product tidak ada
			if (!this.inputs.product_level_id) {
				this.input_product_id = {};
				this.inputs.product_id = null;
				return;
			}

			// fetch package list berdasarkan product id
			this.fetchProductByLevel(this.inputs.product_level_id);

			this.$set(this, "input_product_level_id", data);
		},
		setProductIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;

			// reset package kalau product tidak ada
			if (!this.inputs.product_id) {
				this.input_packages_name = {};
				this.inputs.package_name = null;
				return;
			}

			// fetch package list berdasarkan product id
			this.fetchPackagesByProduct(this.inputs.product_id);

			this.$set(this, "input_product_id", data);
		},
		
		async fetchProductByLevel(productLevelId,product_id='') {
			try {

				const res = await axios.get("/master/product", {
					params: { product_level_id: productLevelId }
				});

				const product = res.data.data || [];
				
				if(product_id !=''){
					const selectedproduct = product.find(p => p.id === id);
					this.input_product_id = selectedPackage;
					this.inputs.product_id = product_id;
					
				}else{
					this.input_product_id = {};
					this.inputs.product_id = null;
				}
			} catch (err) {
				this.input_product_id = {};
				this.inputs.product_id = null;
			}
		},
		async fetchPackagesByProduct(productId,package_name='') {
			try {
				const res = await axios.get("/master/list-packages", {
					params: { product_id: productId }
				});

				// assign data ke dropdown packages
				const packages = res.data.data || [];

				// kalau cuma ada 1 package, langsung pilih otomatis
				// if (packages.length === 1) {
					
				// 	this.input_packages_name = packages[0];
				// 	this.inputs.package_name = packages[0].package_name;
					
				// 	try {
				// 		const res = await axios.get(`/master/packages/name/${packages[0].package_name}/${productId}`);
				// 		const data = res.data;
						
				// 		for (let i = 1; i <= 7; i++) {
				// 			this.inputs[`time_start_${i}`] = "";
				// 			this.inputs[`time_end_${i}`] = "";
				// 		}
				// 		var trainer_teacher = [];
				// 		if (Array.isArray(data.course_list_packages)) {
				// 			data.course_list_packages.forEach(item => {
				// 				const day = item.course?.day;
				// 				const timeStart = item.course?.time_start;
				// 				const timeEnd = item.course?.time_end;
				// 				if(item.trainer_teacher){

				// 				}

				// 				// kalau day valid (1–7)
				// 				if (day >= 1 && day <= 7) {
				// 					this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
				// 					this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
				// 				}
				// 			});
				// 		}
						
				// 		this.$forceUpdate();
				// 	} catch (err) {
				// 		console.error("Gagal mengambil data package:", err);
				// 	}
				// } else {
					
					if(package_name !=''){
						const selectedPackage = packages.find(p => p.package_name === package_name);
  						this.input_packages_name = selectedPackage;
						this.inputs.package_name = package_name;
						
						try {
							const res = await axios.get(`/master/packages/name/${package_name}/${productId}`);
							const data = res.data;
							
							for (let i = 1; i <= 7; i++) {
								this.inputs[`time_start_${i}`] = "";
								this.inputs[`time_end_${i}`] = "";
							}

							if (Array.isArray(data.course_list_packages)) {
								data.course_list_packages.forEach(item => {
									const day = item.course?.day;
									const timeStart = item.course?.time_start;
									const timeEnd = item.course?.time_end;

									// kalau day valid (1–7)
									if (day >= 1 && day <= 7) {
										this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
										this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
									}
								});
							}
							
							this.$forceUpdate();
						} catch (err) {
							console.error("Gagal mengambil data package:", err);
						}
					}else{
						this.input_packages_name = {};
						this.inputs.package_name = null;
					}
				// }
			} catch (err) {
				console.error("Gagal ambil package:", err);
				this.input_packages_name = {};
				this.inputs.package_name = null;
			}
		},
		
		setProductValueEditData(data,package_name){
			
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;

			this.$set(this, "input_product_id", data);

			this.fetchPackagesByProduct(this.inputs.product_id,package_name);

		},
		setProductLevelEditData(data){
			if (data && data.hasOwnProperty("product_level_id")) {
				this.$set(this.inputs, "product_level_id", data.product_level_id );
			}
						
			this.inputs.product_level_id  = data?.product_level_id  || null;

			this.$set(this, "input_product_level_id", data);

			// this.fetchProductByLevel(this.inputs.product_level_id,product_id);

		},
		
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;

			this.inputs.placement_type = response.data.placement_type?.id;
			// this.inputs.examiner = this.inputs.examiner;
			this.input_assignee_id = this.inputs.assignee_id;
			if(this.inputs.placement_type == 3){

				this.showProductLevel = true;
				this.showProduct = true;
				this.showPackageName = true;
				this.showCenterLocationTest = false;
				this.showLocationTest = false;
				this.showBookingDate = false;
				this.showBookingTime = false;
				// this.showStatus = false;
				this.showReason = false;
				this.showAssignTo = false;
				// this.showSubStatus = false;
				let productLevel = {
					product_level_id: null,
					product_level_desc: null,
					product_level_code: null
				}
				if (response.data.product_level?.product_level_id) {
					productLevel = {	
						product_level_id : response.data.product_level.product_level_id,
						level_id: response.data.product_level.level_id,
						product_level_desc: response.data.product_level.product_level_desc,
						product_level_code: response.data.product_level.product_level_code
					};
					this.setProductLevelEditData(productLevel);
				}
				let product = {
					id: null,
					name: null,
					code: null,
					is_active: null
				}
				
				if (response.data.product?.id) {
					this.isEditMode = true;
					product = {
						id: response.data.product.id,
						name: response.data.product.name,
						code: response.data.product.code,
						is_active: response.data.product.is_active
					};
					this.setProductValueEditData(product,response.data.package_name);
				}
			}else{
					
				// this.input_status = {
				// 	id: this.inputs.status?.id || 0,
				// 	status: this.inputs.status?.status || "",
				// };
				
				let center = {
					id: null,
					name: null,
					code: null,
					is_active: null
				}

				if (response.data.center?.id) {
					center = {
						id: response.data.center.id,
						name: response.data.center.name,
						code: response.data.center.code,
						is_active: response.data.center.is_active
					};
				}
			
				this.setCenterValue(center);
		
				// this.input_sub_status = {
				// 	id: this.inputs.sub_status?.id || 0,
				// 	status: this.inputs.sub_status?.status || "",
				// };

				this.inputs.book_time = response.data.book_time.slice(0, -3);
				// this.inputs.status = response.data.status?.id;
				this.inputs.assignee_id = response.data.assignee_id?.id;
				// this.inputs.sub_status = response.data.sub_status?.id;
				// this.showStatus = false;

				if(this.inputs.placement_type !=1){
					this.showProductLevel = false;
					this.showProduct = false;
					this.showPackageName = false;
					this.showLocationTest = true;

					if(this.inputs.location_test == 'Onsite'){
						this.showCenterLocationTest = true;
					}
					
				}else{
					this.showProductLevel = true;
					this.showProduct = true;
					this.showPackageName = true;
					
					
					let productLevel = {
						product_level_id: null,
						product_level_desc: null,
						product_level_code: null
					}
						
					if (response.data.product_level?.product_level_id) {
						productLevel = {
							product_level_id : response.data.product_level.product_level_id,
							level_id: response.data.product_level.level_id,
							product_level_desc: response.data.product_level.product_level_desc,
							product_level_code: response.data.product_level.product_level_code
						};
						
						this.setProductLevelEditData(productLevel);
					}
					let product = {
						id: null,
						name: null,
						code: null,
						is_active: null
					}
					if (response.data.product?.id) {
						this.isEditMode = true;
						product = {
							id: response.data.product.id,
							name: response.data.product.name,
							code: response.data.product.code,
							is_active: response.data.product.is_active
						};
						this.setProductValueEditData(product,response.data.package_name);
					}
					
					this.showCenterLocationTest = false;
					this.showLocationTest = false;
				}
			}

			this.preloader = false;
		},
	},
};
</script>
<style scoped>
::v-deep(.modal-body) {
  min-height: 38vh !important;
}
</style> 